import { jsx as r } from "react/jsx-runtime";
import s from "./Spinner.module.scss.js";
var t = function t() {
  return /* @__PURE__ */r("span", {
    className: s.spinner
  });
};
export { t as default };